"use client";

import React, { createContext, useContext, useState, useCallback } from 'react';

interface JargonBusterContextType {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  resetFilters: () => void;
  isSearching: boolean;
  totalResults: number | undefined;
}

const JargonBusterContext = createContext<JargonBusterContextType | undefined>(undefined);

export function JargonBusterProvider({ children }: { children: React.ReactNode }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [totalResults, setTotalResults] = useState<number | undefined>(undefined);

  const resetFilters = useCallback(() => {
    setSearchTerm('');
    setTotalResults(undefined);
  }, []);

  const value = {
    searchTerm,
    setSearchTerm,
    resetFilters,
    isSearching: searchTerm.length > 0,
    totalResults,
  };

  return (
    <JargonBusterContext.Provider value={value}>
      {children}
    </JargonBusterContext.Provider>
  );
}

export function useJargonBusterContext() {
  const context = useContext(JargonBusterContext);
  if (context === undefined) {
    throw new Error('useJargonBusterContext must be used within a JargonBusterProvider');
  }
  return context;
}